<template>
  <div class="container">
    <div v-if="goodsList.length > 0">
      <div class="head-info">
        <div class="radio-container">
          <el-checkbox
            v-model="checked"
            class="el-radio"
            @change="allCheck"
          ></el-checkbox>
          <div class="radio" :class="checked ? 'select' : ''"></div>
        </div>
        <span class="span1">全选</span>
        <span class="span2">商品信息</span>
        <span class="span3">单价 (元)</span>
        <span class="span4">数量</span>
        <span class="span5">小计 (元)</span>
        <span class="span6">操作</span>
      </div>

      <div
        v-for="(item, index) in goodsList"
        class="cart-goods-list"
        :key="item.cartItemId"
      >
        <div class="radio-container c-radio-container">
          <div
            class="radio c-pointer"
            @click="select(index)"
            :class="goodsItem[index].checked ? 'select' : ''"
            v-if="!goodsItem[index].disable"
          ></div>
          <div class="radio no-select" v-else></div>
        </div>
        <cart-goods-item
          ref="goodsItem"
          class="cart-goods-item"
          :key="item.cartItemId"
          :index="index"
          :itemData="item"
          :checked="goodsItem[index].checked"
          @del="del"
          @updateCartList="getCartList('update')"
        ></cart-goods-item>
      </div>
      <div class="goBack c-pointer">
        <img :src="require('@/assets/images/icon_return.png')" alt="" />
        <router-link tag="span" to="/home">返回继续购物</router-link>
      </div>

      <div class="count" ref="count" :class="isfixed ? 'fixed' : 'relative'">
        <div class="radio-container">
          <el-checkbox
            v-model="checked"
            class="el-radio"
            @change="allCheck"
          ></el-checkbox>
          <div class="radio" :class="checked ? 'select' : ''"></div>
        </div>
        <span class="span1">全选</span>
        <span class="span2"
          >已选择<i>{{ totalData.num }}</i
          >件商品</span
        >

        <span class="span3 fr" @click="toCount">去结算</span>

        <div class="total-amount-wrapper fr" v-if="totalData.num != 0">
          <p class="p1">
            合计(不含运费) <label class="label">￥{{ totalData.total }}</label>
          </p>
          <p class="p2">已优惠{{ totalData.couponAmount }}</p>
        </div>

        <span class="span4 fr" v-if="totalData.num == 0"
          >￥{{ totalData.total }}</span
        >
        <span class="span5 fr" v-if="totalData.num == 0">合计(不含运费) </span>
      </div>
    </div>
    <div v-if="cartIsEmpty" class="empty">
      <div class="empty-img">
        <img :src="require('@/assets/images/gouwuc.png')" alt="" />
      </div>
      <span>当前购物车为空</span>
    </div>
    <success v-if="successShow">删除成功</success>
    <error v-if="errorShow">{{ message }}</error>
  </div>
</template>
<script>
import cartGoodsItem from "./cart-goods-item.vue";

export default {
  components: { cartGoodsItem },
  data() {
    return {
      cartIsEmpty: false,
      goodsList: [],
      checked: false,
      goodsItem: [],
      totalData: "",
      arr: ["1"],
      goodsIdList: [],
      successShow: false,
      errorShow: false,
      message: "",
      isfixed: false
    };
  },
  created() {
    this.getCartList();
  },
  mounted() {
    // this.init();

    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    islimited(num, limited, limitedCount) {
      if (limited) {
        return limitedCount >= num;
      } else {
        return true;
      }
    },
    async getCartList(source) {
      //获取购物车列表
      const list = await this.$store.dispatch("getCartList");
      if (source == "update") {
      } else {
        for (let i of list) {
          this.goodsItem.push("");
        }
      }
      this.goodsList = list;
      this.cartIsEmpty = list.length === 0;
      this.init();
      // this.$api.GET_CART().then((res) => {
      //   if (res.status) {
      //     if (source == "update") {
      //     } else {
      //       for (let i of res.data.items) {
      //         this.goodsItem.push("");
      //       }
      //     }

      //     this.goodsList = res.data.items;
      //     this.cartIsEmpty = res.data.items.length === 0;

      //     this.init();
      //   }
      // });
    },
    del({ cartItemId, index }) {
      this.$api.POST_DELCART({ cartItemId }).then(res => {
        if (res.status) {
          // this.successShow = true
          // this.goodsItem = [];
          // this.goodsList = [];
          //  this.getCartList()

          this.total({ index }, true);
          this.goodsList.splice(index, 1);
          this.cartIsEmpty = this.goodsList.length === 0;
          this.init();
        }
      });
    },
    success() {
      this.successShow = false;
    },
    error() {
      this.errorShow = false;
    },
    toCount() {
      let arr = [];
      this.goodsItem.map(item => {
        if (item.checked && !item.disable) {
          arr.push(item.cartItemId);
        }
      });
      if (arr.length <= 0) {
        this.errorShow = true;
        this.message = "请选择商品";
        return;
      }
      //console.log(arr);
      this.$api
        .POST_OREDERPRE({
          orderSubmitType: "cart",
          source: "web",
          cartItemIds: arr.join()
        })
        .then(res => {
          // console.log("预处理",res);
          if (res.status) {
            this.$router.push({
              path: "verify",
              query: { cartItemIds: arr.join() }
            });
          } else {
            this.errorShow = true;
            this.message = res.message;
          }
        });
    },
    total(data, del = false) {
      if (del) {
        this.goodsItem.splice(data.index, 1);
      } else {
        this.goodsItem[data.index] = data;
      }

      let num = 0,
        total = 0,
        couponAmount = 0;
      this.goodsItem.map(item => {
        if (item.checked && !item.disable) {
          num = num + Number(item.num);
          total = total + Number(item.subPrice);
          couponAmount = couponAmount + Number(item.couponAmount);
        }
      });
      // console.log(this.goodsItem)
      this.totalData = {
        num,
        total: total.toFixed(2),
        couponAmount: couponAmount.toFixed(2)
      };
    },

    //全选/反选
    allCheck() {
      //console.log(this.checked,this.goodsItem)

      if (this.checked) {
        this.goodsItem.forEach((item, index) => {
          if (!item.disable) {
            item.checked = true;
          }
        });
      } else {
        this.goodsItem.forEach((item, index) => {
          item.checked = false;
        });
      }
    },
    // 判断是否全选
    checkedAll() {
      let temp = this.goodsItem.some((item, index, array) => {
        return item.checked == false;
      });
      //	console.log(temp)
      if (!temp) {
        // 全选
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    // 单选
    select(index) {
      // if(!this.goodsList[index].stock && !this.goodsList[index].status && this.goodsList[index].isOutofstok){
      //   this.goodsItem[index].checked=false
      // }

      this.$set(this.goodsItem, [index], {
        ...this.goodsItem[index],
        checked: !this.goodsItem[index].checked
      });
      this.checkedAll();
    },
    handleScroll(e) {
      // console.log(e, "=====handleScroll=====");
      let scrollTop =
        e.target.documentElement.scrollTop || e.target.body.scrollTop;
      let scrollHeight =
        e.target.documentElement.scrollHeight || e.target.body.scrollHeight;
      let screeHeight = Number(document.body.clientHeight);

      scrollHeight = scrollHeight - 36;
      // console.log(scrollTop, scrollHeight, screeHeight);
      this.$nextTick(() => {
        if (this.$refs.count.style.position == "relative") {
          scrollHeight = scrollHeight - 120;
        }

        if (scrollHeight - scrollTop > screeHeight) {
          this.$refs.count.style = "position:fixed";
        }

        if (scrollHeight - scrollTop <= screeHeight) {
          this.$refs.count.style = "position:relative";
          this.$refs.count.style.marginBottom = 20 + "px";
        }
      });
    },
    init() {
      this.$nextTick(() => {
        let scrollHeight = document.documentElement.scrollHeight;
        scrollHeight = scrollHeight - 36;
        let screeHeight = document.body.clientHeight;
        // console.log(scrollHeight, screeHeight);

        if (scrollHeight > screeHeight) {
          this.isfixed = true;
        } else {
          this.isfixed = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 252px);

  .head-info {
    position: relative;
    padding-left: 20px;
    background: #fafafa;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #808080;
    margin-bottom: 16px;
    .span1 {
      margin: 0 30px;
    }
    .span2 {
      margin-right: 478px;
    }
    .span3 {
      margin-right: 140px;
    }
    .span4 {
      margin-right: 100px;
    }
    .span5 {
      margin-right: 90px;
    }
  }
}

.cart-goods-list {
  position: relative;
}
.cart-goods-item {
  padding: 14px 0 14px 78px;
  border: 1px solid #f5f5f5;
  margin-bottom: 20px;
  border-radius: 4px;
}
.radio-container {
  display: flex;
  position: absolute;
  align-items: center;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  .el-radio {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    /deep/ .el-checkbox__inner {
      width: 20px;
      height: 20px;
    }
  }
  .radio {
    width: 20px;
    height: 20px;
    border: 0;
    background: url("../../../assets/images/xxxx_xxhdpi.png");
    display: inline-block;
    background-size: 100% 100%;
  }
  .select {
    border: 0;
    background: url("../../../assets/images/icon_g.png");
    background-size: 100% 100%;
  }
  .no-select {
    border: 0;
    background: url("../../../assets/images/xxxx2_xxhdpi.png");
    background-size: 100% 100%;
  }
}
.goBack {
  font-size: 14px;
  margin: 24px 0;
  color: #666666;
  display: flex;
  align-items: center;

  img {
    width: 6px;
    height: 8px;
    margin-right: 8px;
  }
}

.count {
  overflow: hidden;
  height: 60px;
  border: 1px solid #f5f5f5;
  position: relative;
  line-height: 60px;
  padding-left: 20px;
  width: 1200px;
  background: #fff;
  z-index: 100;
  bottom: 0;
  .span1 {
    margin-left: 30px;
    margin-right: 20px;
    color: #666666;
  }
  .span2 {
    color: #666666;
    i {
      color: #fa4b4b;
      font-weight: 600;
      margin: 0 4px;
    }
  }
  .span3 {
    cursor: pointer;
    width: 121px;
    text-align: center;
    color: #ffffff;
    font-weight: 600;
    font-size: 17px;
    background: #fa4b4b;
  }
  .span4 {
    margin-right: 24px;
    font-size: 16px;
    font-weight: 600;
    color: #fa4b4b;
  }
  .span5 {
    margin-right: 20px;
    color: #666666;
    font-size: 14px;
  }
}
.c-radio-container {
  transform: none !important;
  top: 75px !important;
}

.empty {
  margin-top: 200px;
  align-items: center;
  @include flex-d-c;
  .empty-img {
    margin-bottom: 16px;
  }
  span {
    font-size: 18px;
    color: #333333;
    font-weight: bold;
  }
}
.total-amount-wrapper {
  height: 60px;
  margin-right: 34px;
  .p1 {
    height: 30px;
    line-height: 42px;
  }
  .p2 {
    height: 30px;
    line-height: 22px;
    font-size: 12px;
    color: #fa4b4b;
    text-align: right;
  }
  .label {
    font-size: 16px;
    font-weight: 600;
    color: #fa4b4b;
    margin-left: 20px;
  }
}
.fixed {
  position: fixed;
}
.relative {
  position: relative !important;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cart/components/cart-goodsList.vue